
angular.module('web2print.recipients')
  .controller('RecipientsController', function ($localStorage, $log, $state, Common, $location,
    sidebarMyOrderFactory, recipientsFactory, $scope, $timeout, FeatureToggleFactory,
    addressCalculationFactory, $uibModal, $translate, productsFactory, $rootScope) {
    const vm = this;

    vm.switchRecipientRole = switchRecipientRole;
    vm.recipientRole = 'own';
    vm.isPreviousAddresses = isPreviousAddresses;
    vm.isNewAddresses = isNewAddresses;
    vm.isOwnAddresses = isOwnAddresses;
    vm.goBack = goBack;
    vm.hasChanged = hasChanged;
    vm.storeSender = storeSender;
    vm.getAddingAddressStatus = getAddingAddressStatus;
    vm.isSubmitValid = isSubmitValid;

    vm.completePage = completePage;
    vm.showSenderForm = true;
    vm.errorWhenAdding = false;

    vm.selectTab = selectTab;
    vm.isTabSelected = isTabSelected;
    vm.selectChip = selectChip;
    vm.isChipSelected = isChipSelected;
    vm.showODRTab = showODRTab;
    vm.showADRTab = showADRTab;
    vm.getMaskByMarket = getMaskByMarket;
    vm.getMaxLengthByMarket = getMaxLengthByMarket;
    vm.getPostalErrorByMarket = getPostalErrorByMarket;
    vm.showErrorToast = showErrorToast;

    function showErrorToast () {
      const text = $translate.instant('ODR_DISTBANCE_BANER_TOAST_RECIPIENTS');
      const result = text.length > 1 && text !== 'ODR_DISTBANCE_BANER_TOAST_RECIPIENTS';
      console.log(result);
      return result;
    }

    const getAddressLimit = recipientsFactory.addressLimit; // min/max values for amount of recipients

    checkSession();
    ///////////////////////
    function checkSession () {
      const action = {
        0: angular.noop,
        1: Common.resetOrderData
      };

      if (Common.get('paymentStatus', false) === 'SUCCESS' || !Common.get('serviceType', null)) {
        action[Number(Common.get('orderId', null) !== null)]();
        $location.path('/');
        return;
      }

      if (Common.get('serviceType', 'information') === 'admail-odr' && !$rootScope.isNCPUser()) {

        if (pnTopbar.isLoggedIn) {
          $location.path('/');
        } else {
          pnTopbar.login();
        }

        return;
      }

      activate();
    }

    function activate () {
      // FEATURE TOGGLE
      vm.showODR = FeatureToggleFactory.isFeatureEnabled('odrEnabled');
      vm.showErrorToast = showErrorToast();
      // FEATURE TOGGLE END

      $log.log('RecipientsController : activate : selected', $localStorage.selected);
      vm.validAddresses = parseInt(Common.get('recipients.validAddressCount', 0));
      vm.sendoutName = Common.get('sendoutName', '');
      vm.isAdmail = Common.get('serviceType', '').indexOf('admail-') > -1;

      vm.senderInfo = $localStorage.senderInformation
        ? angular.copy($localStorage.senderInformation) : extractUserProfile();
      vm.addressInfo = $localStorage.addressInfo ? angular.copy($localStorage.addressInfo) : Common.get('addressInfo');
      vm.saveSender = $localStorage.senderInformation ? true : false;
      vm.senderInfoOriginal = angular.copy(vm.senderInfo);
      vm.currentForm = Common.get('currentForm', 'private');
      vm.selectedTab = Common.get('recipients.addressType'); // setting this to null as of now. default values for this function is not working
      vm.selectedChip = Common.get('recipients.targetType');
      //vm.odrAlone = Common.get('serviceType', '') === 'admail-odr' ? true : false;
      vm.shouldBeODR = Common.get('serviceType', '') === 'admail-flyers' || Common.get('serviceType', '') === 'admail-postcard';
      vm.shouldBeADR = Common.get('serviceType', '') === 'admail-letter' || Common.get('serviceType', '') === 'admail-postcard';
      //vm.humanyGuide = humanyGuide;

      if (angular.isDefined(vm.parcel) && (vm.parcel.sender || vm.parcel.receiver)) {
        vm.sender = vm.parcel.sender;
        vm.saveSenderInformation = true;
        vm.receiver = vm.parcel.receiver;
      } else if ($localStorage.sender) {
        vm.sender = angular.copy($localStorage.sender);
      }

      if (vm.validAddresses) {
        vm.doneAddresses = true;
      }

      vm.saveSenderInformation = angular.isUndefined($localStorage.saveSenderInformation)
        || $localStorage.saveSenderInformation;
      vm.showSenderForm = !isSenderFormValid(vm.sender);
      vm.validColumns = Common.get('validColumns', true);

      Common.registerObserver('updateValidAddresses', updateValidAddresses);

      if (recipientsFactory.isNCP && pnTopbar.isLoggedIn) {
        fetchCustomers();
      }

      if (!vm.selectedTab) {
        vm.selectedTab = addressCalculationFactory.getDefaultTab();
      }

      if (!vm.selectedChip) {
        vm.selectedChip = resolveChipDefault();
      }

      setDefaultSendOutName();

      productsFactory.fetchProducts(true);
    }

    function extractUserProfile () {
      const senderInfo = Common.get('senderInfo', {
        country: pnTopbar.market
      });
      const userInfo = Common.get('userProfile', null);

      if (userInfo && Object.keys(senderInfo).length < 2) {
        senderInfo.addressLineOne = userInfo.firstName + ' ' + userInfo.lastName;
        senderInfo.street = '';
        senderInfo.zipcode ='';
        senderInfo.city = '';
        senderInfo.country = pnTopbar.market || 'SE';
        Common.set('senderInfo', senderInfo);
      }

      return senderInfo;
    }

    function fetchCustomers () {
      vm.fetchingCustomers = true;
      recipientsFactory.fetchCustomers()
        .then(function (res) {
          vm.fetchingCustomers = false;
          vm.customers = recipientsFactory.modifyCustomerResponse(res);
          vm.senderInfo.company = vm.senderInfo.company ? vm.senderInfo.company : vm.customers[0];
          vm.senderInfoOriginal = angular.copy(vm.senderInfo);
        }, function (err) {
          console.log(err);
          vm.fetchingCustomers = false;
        })
        .catch(function (err) {
          console.log(err);
          vm.fetchingCustomers = false;
        });
    }

    function getAddingAddressStatus () {
      return recipientsFactory.checkAddingAddresses();
    }

    function storeSender (store) {
      if (store) {
        $localStorage.senderInformation = angular.copy(vm.senderInfo);
      } else {
        delete $localStorage.senderInformation;
      }
    }

    function hasChanged () {
      const current = vm.senderInfo;
      const stored = vm.senderInfoOriginal;
      const pristine = current.addressLineOne === stored.addressLineOne &&
        current.addressLineTwo === stored.addressLineTwo &&
        current.street === stored.street &&
        current.zipcode === stored.zipcode &&
        current.city === stored.city &&
        current.country === stored.country;

      Common.set('pristine', pristine);
      Common.set('sendoutName', vm.sendoutName);
      storeSender(vm.saveSender);
    }

    function updateValidAddresses () {
      vm.validAddresses = parseInt(Common.get('recipients.validAddressCount', 0));
      vm.validColumns = Common.get('validColumns', true);
    }

    function completePage () {
      let stateToGo = 'main.whereTo';
      vm.errorWhenAdding = false;
      Common.set('sendoutName', vm.sendoutName);
      Common.set('senderInfo', recipientsFactory.checkAddress(vm.senderInfo));
      Common.set('currentForm', vm.currentForm);

      storeSender(vm.saveSender);

      if (!sidebarMyOrderFactory.addressProcessing && Common.get('recipients.targetType') === 'FILE') {
        Common.notifyObserver('updateAddresses');
      }

      if (vm.recipientsForm.$valid) {
        vm.nextState = 'main.payment';

        if (vm.isAdmail && Common.get('recipients.addressType', 'ADR') === 'ODR') {
          stateToGo = 'main.odrWhereTo';
        }

        $state.go(stateToGo);
        vm.nextState = undefined;
      }
    }

    function isSenderFormValid (sender) {
      const requiredProperties = ['company.name', 'company.organizationNumber', 'recipients.zipCode', 'recipients.city',
        'email'];
      const res = _.every(requiredProperties, function (p) {
        return _.has(sender, p);
      });
      return res;
    }

    function switchRecipientRole (state) {
      vm.recipientRole = state;
    }

    function isPreviousAddresses () {
      return vm.recipientRole === 'previous';
    }

    function isNewAddresses () {
      return vm.recipientRole === 'new';
    }

    function isOwnAddresses () {
      return vm.recipientRole === 'own';
    }

    function goBack () {
      const states = {
        'admail-letter': 'main.admail',
        'admail-postcard': 'main.admail',
        'admail-odr': 'main.admail',
        'admail-flyers': 'main.admail',
        'information': 'main.landing',
        'paymentSlips': 'main.landing',
      };

      $state.go(states[Common.get('serviceType', 'information')]);
    }

    function resetAndSelectTab (tabName) {

      recipientsFactory.switchAddressType();

      vm.selectedTab = tabName;
      if (tabName === 'ODR' && vm.selectedChip === 'FILE') {
        // set to default if the FILE tab disappeared.
        selectChip('INDIVIDUALS');
      }

      // remove product data from the next page to avoid errors during onload
      if (Common.get('productDelivery')) {
        Common.remove('productDelivery');
      }

      if (Common.get('materialDetails', false) && Common.get('serviceType', 'information') === 'admail-postcard') {
        Common.set('changedAddress', true);
      }

      Common.set('recipients.addressType', tabName);
      Common.set('pricing', {});
    }

    function openConfirmationModal (tabName) {
      $uibModal.open({
        templateUrl: 'components/recipients/postal-removal-confirmation/codesRemovalConfirmation.html',
        controller: 'PostalcodeRemovalCtrl',
        controllerAs: 'ctrl',
        backdrop: 'static',
        backdropClass: 'common-modal-backdrop',
        resolve: {
          tabName: () => {
            return tabName;
          }
        }
      }).result.then(resetAndSelectTab);
    }

    function selectTab (tabName) {
      if (tabName !== Common.get('recipients.addressType')) {
        const zipcodes = Common.get('zipcodes');
        const odrGroup = Common.get('recipients.odrGroup', {});
        if (zipcodes || odrGroup.refinedAddressCount) {
          openConfirmationModal(tabName);
          return;
        }

        resetAndSelectTab(tabName);
      }

    }

    function isTabSelected (tabName) {
      return vm.selectedTab === tabName;
    }

    function selectChip (chipName) {
      vm.selectedChip = chipName;
      Common.set('recipients.targetType', chipName);
      if (Common.get('productDelivery', false) && Common.get('recipients.addressType') === 'ODR') {
        Common.remove('productDelivery', null);
      }

      $scope.$broadcast('chipSelected'); // used in odr controller to detect when chip was updated
      $timeout(function () {
        $scope.$broadcast('rzSliderForceRender');
        // render purchasing power slider when switching from another chip
      }, 0, false);
    }

    function isChipSelected (chipName) {
      return vm.selectedChip === chipName;
    }

    function resolveChipDefault () {
      if (vm.isAdmail) {
        Common.set('recipients.targetType', 'INDIVIDUALS');
        return 'INDIVIDUALS';
      } else {
        Common.set('recipients.addressType', 'FILE');
      }
    }

    function getCount () {
      const addressType = Common.get('recipients.addressType');
      const targetType = Common.get('recipients.targetType');

      if ((addressType === 'ADR' || addressType === 'ODR') && targetType !== 'FILE') {
        return Common.get('recipients.refinedAddressCount', 0);
      } else if (addressType === 'FILE' || targetType === 'FILE') {
        return vm.validAddresses;
      }
    }

    function showODRTab () {
      const isAdmailFlyer = Common.get('serviceType', 'information') === 'admail-flyers';
      const isPostcard = Common.get('serviceType', 'information') === 'admail-postcard';

      return isAdmailFlyer || isPostcard;
    }

    function showADRTab () {
      const isAdmailLetter = Common.get('serviceType', 'information') === 'admail-letter';
      const isPostcard = Common.get('serviceType', 'information') === 'admail-postcard';

      return isAdmailLetter || isPostcard;
    }

    function isSubmitValid () {
      const addressType = Common.get('recipients.addressType');

      const isFetching = addressCalculationFactory.getUpdateSyncParams();
      const isIdle = !isFetching.isFetchingRefinedCount
        && !isFetching.isFetchingGrossCount;

      const count = getCount();
      const limit = getAddressLimit();

      const boundsConditions = {
        0: count > 0,
        1: count >= limit.min && limit.max >= count
      };

      const isInBounds = boundsConditions[Number(Common.get('serviceType') !== 'admail-odr')];
      const formValid = vm.recipientsForm.$valid;

      switch (addressType) {
        case 'ADR':
          return formValid && isInBounds && isIdle;

        case 'ODR':
          return formValid && isInBounds && isIdle;

        case 'FILE':
          return formValid && isInBounds;

        default:
          console.warn('Could not resolve validation for submit.');
          break;
      }
    }

    function getMaskByMarket () {
      const market = {
        SE: '999 99',
        DK: '9999'
      };

      return market[pnTopbar.market];
    }

    function getMaxLengthByMarket () {
      const market = {
        SE: 5,
        DK: 4
      };

      return market[pnTopbar.market];
    }

    function getPostalErrorByMarket () {
      const messages = {
        SE: 'RECIPIENTS_PAGE_ERROR_POSTAL_LENGTH',
        DK: 'RECIPIENTS_PAGE_ERROR_POSTAL_LENGTH_DK'
      };

      return messages[pnTopbar.market || 'SE'];
    }

    function setDefaultSendOutName () {
      $timeout(function () {
        const serviceType = Common.get('serviceType', 'information');
        const serviceName = $translate.instant(Common.getServiceNameTranslationKey(serviceType));
        vm.sendoutName = serviceName + ' - ' + getDateTime();
      }, 100);
    }

    function getDateTime () {
      return moment().local().format('YYYY/MM/DD HH:mm:ss').toString();
    }

    $scope.$on('marketChanged', () => {
      // NOTE: for now, its just postal code
      vm.senderInfo.zipcode = null;
      hasChanged();
    });

    $scope.$on('changeLanguage', function (events, language) {
      setDefaultSendOutName();
    });
  });
